<template>
  <nav class="app-nav"  v-dragscroll>
    <ul class="menu" :class="navStateClass" :data-itemcount="navigation.length">
      <li class="menu-item" v-for="(data,idx) in this.navigation" v-bind:key="data.title"
          v-on:animationend="closed">
        <router-link :to="data.endpoint" :key="idx" class="menu-link">
          <img :src="data.icon" :alt="data.title" />
          <span>{{ data.title }}</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
  // import store from "../utils/store";
  import { NAVIGATION_OPEN } from '../utils/store/actions/general';

  import api, { ApiDefaults } from '@/utils/api_call';
  import store from "@/utils/store";
  // import debounce from 'lodash.debounce';
  import { dragscroll } from 'vue-dragscroll';

  export default {
    name: "KappMainNav",
    data() {
      return {
        menu: [],
        isOpen: false,
        isOpening: false,
        isClosing: false
      };
    },
      directives: {
          dragscroll
      },
    props: {
      status: {
        type: String,
        required: false
      },
      type : {
        type: String,
        default: 'circle'
      }
    },
    computed: {

      navStateClass: function () {
        let navClass = '';
        if ( this.isClosing ) {
          navClass += ' ' + 'is-closing';
        }
        else {
          navClass += ' ' + this.$store.getters.navigationState;
        }
        switch( this.type ) {
          case 'circle':
            navClass += ' menu--circle'; break;
          case 'shelf':
            navClass += ' menu--shelf'; break;
        }

        return navClass;
      },
      allowedNavigation: function () {
        let list = [];

        this.menu.forEach(( item ) => {
            // if( [10, 16, 2].indexOf(item.uid) === -1 )
                list.push(item.uid); // excluded pages from Navigation
        });

        list.push(999);

        return list;
      },
      navigation: function () {
       // let list = this.$router.options.routes ;
        let list = [
          // {
          //   uid: 34,
          //   title: 'Schwarzes Brett',
          //   // name: 'Aktuelles',
          //   icon: require('@/assets/images/icons/ic_dashboard.svg'),
          //   endpoint: {name: 'AktuellesListe'}
          // },
            {  uid: 35,
            title: 'Eure Beiträge',
            // name: 'Aktuelles',
            icon: require('@/assets/images/icons/ic_dashboard.svg'),
            endpoint: {name: 'ImpressionsList'}
          },
            {  uid: 999,
            title: 'Social Media',
            // name: 'Aktuelles',
            icon: require('@/assets/images/icons/ic_instagram.svg'),
            endpoint: {name : 'SocialMedia'}
          },
          // {
          //   uid: 2,
          //   title: 'Neuigkeiten',
          //   name: 'Neuigkeiten',
          //   icon: require('@/assets/images/icons/ic_aktuelles.svg'),
          //   endpoint: {name: 'Neuigkeiten'}
          // },
          // {
          //   uid: 0, // App eigene Seite
          //   title: this.$store.getters.getProfile.fullName,
          //   name: 'Profile',
          //   // icon: this.$store.getters.getProfileImage,
          //   icon: require('@/assets/images/icons/ic_profil.svg'),
          //   endpoint: {name: 'Profile'},
          //   required: true
          // },
          {
            uid: 11,
            title: 'Nachrichten',
            name: 'Nachrichten',
            icon: require('@/assets/images/icons/ic_chats.svg'),
            endpoint: {name: 'Nachrichten'}
          },
          // {
          //   uid: 10,
          //   title: 'Barometer',
          //   name: 'Barometer',
          //   icon: require('@/assets/images/icons/ic_barometer.svg'),
          //   endpoint: {name: 'Barometer'}
          // },
          {
            uid: 4,
            title: 'Infocenter',
            name: 'Infocenter',
            icon: require('@/assets/images/icons/ic_infocenter.svg'),
            endpoint: {name: 'Infocenter', params: {slug: 'alles'}}
          },
          {
            uid: 12,
            title: 'Kontakte',
            name: 'Kontakte',
            icon: require('@/assets/images/icons/ic_kontakte.svg'),
            endpoint: {name: 'Kontakte'}
          },
          {
            uid: 13,
            title: 'Kalender',
            name: 'Kalender',
            icon: require('@/assets/images/icons/ic_kalender.svg'),
            endpoint: {name: 'Kalender'}
          }
        ];

        list = list.filter(( item ) => {

                return this.allowedNavigation.includes(item.uid) || item.required;

        });
        return list;
      }
    },
    methods: {
      openNavi: function () {
        this.isOpening = true;
      },
      closeNavi: function ( state ) {
        this.isClosing = true;
      },
      closed: function () {
        if ( this.isClosing ) {
          this.isOpen = false;
          this.$store.commit(NAVIGATION_OPEN, 'is-opening');
        }
        else {
          this.$store.commit(NAVIGATION_OPEN, 'is-open');
        }
      },
      fetchMenu: function () {
        let storedItems = store.getters.getNavigationItems;

        if( storedItems.length > 0 ) {
          this.menu = storedItems;
          this.isOpen = true;
        }
        else {
          let apiParams = Object.assign({}, ApiDefaults, {method: 'get', params: {id: 1, type: 1}});
          this.isOpen = false;
          api(apiParams).then(( response ) => {

            if ( response.status === 200 ) {
              let pages = response.data.menu.pages;
              this.menu = pages;
              this.isOpen = true;
            }
          });
        }
      }
    },
    created() {
      this.fetchMenu();
    },
    mounted() {
      this.$nextTick(() => this.openNavi());
      // Events.$on('logout', this.closeNavi);

    }

  };
</script>

<style scoped>
  .app-nav {
      overflow: hidden;
      margin-left: -30px;
      margin-right: -30px;
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 22px;
      border-bottom: 2px solid #1A2026;
      margin-bottom: 22px;
  /*  min-height: calc(100vh - 224px);*/
  }

  .expand-enter-active {
    /*animation: expand 10s linear forwards;*/
    transition: all 10s linear;
  }

</style>



// WEBPACK FOOTER //
// src/components/KappMainNav.vue